import { IconProps } from "../../utils/global-types/global-types";

const CameraIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-5 h-5"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M12.804 6.392h-1.043l-.576-.87a1.2 1.2 0 0 0-.99-.522h-2.39c-.392 0-.772.196-.99.522l-.576.87H5.196C4.533 6.392 4 6.924 4 7.587v4.218C4 12.468 4.533 13 5.196 13h7.608c.663 0 1.196-.533 1.196-1.196V7.587c0-.663-.533-1.195-1.196-1.195M9 12.022a2.695 2.695 0 0 1-2.696-2.695A2.686 2.686 0 0 1 9 6.642a2.695 2.695 0 0 1 2.696 2.695A2.693 2.693 0 0 1 9 12.022m3.652-3.945h-.478a.353.353 0 0 1 0-.707h.435a.353.353 0 0 1 .37.337.344.344 0 0 1-.327.37"
    ></path>
    <path
      fill="currentColor"
      d="M9 7.837c-.826 0-1.5.674-1.5 1.5 0 .827.674 1.49 1.5 1.49s1.5-.674 1.5-1.5c0-.827-.674-1.49-1.5-1.49"
    ></path>
  </svg>
);

export default CameraIcon;
